var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _circle, _rect19, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInteraction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 562,
    viewBox: "0 0 1000 562",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 562,
    fill: "#1b1f27"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 30,
    width: 150,
    height: 30,
    fill: "#ffffff",
    rx: 4,
    fillOpacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 30,
    width: 150,
    height: 30,
    fill: "#ffffff",
    rx: 4,
    fillOpacity: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 80,
    width: 480,
    height: 400,
    rx: 8,
    fill: "#232834",
    stroke: "#334155"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 100,
    width: 440,
    height: 360,
    fill: "#ffffff",
    rx: 4,
    fillOpacity: 0.95
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 120,
    width: 200,
    height: 25,
    fill: "#334155",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 160,
    width: 380,
    height: 12,
    fill: "#cbd5e1",
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 180,
    width: 360,
    height: 12,
    fill: "#cbd5e1",
    rx: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 200,
    width: 380,
    height: 12,
    fill: "#cbd5e1",
    rx: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 120,
    width: 140,
    height: 180,
    fill: "#94a3b8",
    rx: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 80,
    width: 480,
    height: 400,
    rx: 8,
    fill: "#232834",
    stroke: "#334155"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 100,
    width: 440,
    height: 360,
    fill: "#ffffff",
    rx: 4,
    fillOpacity: 0.95
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 120,
    width: 200,
    height: 25,
    fill: "#334155",
    rx: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 160,
    width: 380,
    height: 12,
    fill: "#cbd5e1",
    rx: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 180,
    width: 360,
    height: 12,
    fill: "#cbd5e1",
    rx: 1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 200,
    width: 380,
    height: 12,
    fill: "#cbd5e1",
    rx: 1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 120,
    width: 140,
    height: 180,
    fill: "#94a3b8",
    rx: 2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 500,
    width: 980,
    height: 50,
    rx: 8,
    fill: "#232834",
    stroke: "#334155"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 525,
    r: 15,
    fill: "#334155"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 515,
    width: 840,
    height: 20,
    fill: "#60a5fa",
    rx: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 525,
    r: 15,
    fill: "#334155"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520 525L520 543L524 539L530 545L534 541L528 535L532 531L520 525Z",
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteraction);
export default __webpack_public_path__ + "static/media/interaction.4867849921160dfd7e086f37a32609f7.svg";
export { ForwardRef as ReactComponent };